import { Link, useParams } from "react-router-dom";

import CreateOrder from "@/app/shared/ecommerce/order/create-order";
import { orderData } from "@/app/shared/ecommerce/order/order-form/form-utils";
import PageHeader from "@/app/shared/page-header";
import routes from "@/routers/routes";
import { Button } from "rizzui";

// TODO: Need added Order date default value

const pageHeader = {
    title: "Edit Order",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "E-Commerce",
        },
        {
            href: routes.eCommerce.orders,
            name: "Orders",
        },
        {
            name: "Edit",
        },
    ],
};

export default function EditOrderPage() {
    const { id } = useParams();
    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <Link
                    to={routes.eCommerce.orders}
                    className="mt-4 w-full @lg:mt-0 @lg:w-auto"
                >
                    <Button
                        as="span"
                        className="w-full @lg:w-auto"
                        variant="outline"
                    >
                        Cancel
                    </Button>
                </Link>
            </PageHeader>
            <CreateOrder id={id} order={orderData} />
        </>
    );
}
